import { ROUTES } from '@/app/router/constants'
import {
  BellIcon,
  BookmarkIcon,
  HomeIcon,
  MessageIcon,
  SettingsIcon,
  type IconProps,
} from '@/shared/icons'

export interface NavItemDefinition {
  value: string
  label: string
  to: string
  Icon: (props: IconProps) => React.JSX.Element
  /** Показывать ли пункт в нижней навигации на телефоне. */
  mobile: boolean
}

/**
 * Разделы соцсети.
 *
 * На телефоне в нижнюю панель помещается четыре пункта — пятый превращает
 * подписи в обрубки. «Настройки» уезжают в меню профиля, где им и место.
 */
export const NAV_ITEMS: NavItemDefinition[] = [
  { value: 'feed', label: 'Лента', to: ROUTES.feed, Icon: HomeIcon, mobile: true },
  { value: 'messages', label: 'Сообщения', to: ROUTES.messages, Icon: MessageIcon, mobile: true },
  {
    value: 'notifications',
    label: 'Уведомления',
    to: ROUTES.notifications,
    Icon: BellIcon,
    mobile: true,
  },
  {
    value: 'bookmarks',
    label: 'Закладки',
    to: ROUTES.bookmarks,
    Icon: BookmarkIcon,
    mobile: true,
  },
  { value: 'settings', label: 'Настройки', to: ROUTES.settings, Icon: SettingsIcon, mobile: false },
]

/**
 * Половины продукта. Рельс переключает не раздел, а микрофронт —
 * это самый верхний уровень навигации в приложении.
 */
export const SURFACES = [
  { id: 'social', label: 'Соцсеть', route: ROUTES.feed, hint: 'Лента, профили, подписки' },
  { id: 'spaces', label: 'Спейсы', route: ROUTES.messages, hint: 'Каналы, треды и голос' },
] as const

export const MOBILE_NAV_LABEL = 'Основные разделы'
export const SIDEBAR_LABEL = 'Разделы соцсети'
export const RAIL_LABEL = 'Части приложения'

export const SEARCH_PLACEHOLDER = 'Поиск людей, спейсов и постов'

export const TRENDS_TITLE = 'Сейчас обсуждают'
export const ONLINE_TITLE = 'Сейчас в сети'

export const CONNECTION_TEXT = {
  idle: 'Реальное время выключено',
  connecting: 'Подключаемся…',
  connected: 'На связи',
  reconnecting: 'Связь потеряна, восстанавливаем',
  disconnected: 'Нет соединения',
} as const

export const LOGOUT_LABEL = 'Выйти'
export const PROFILE_MENU_LABEL = 'Меню профиля'
export const OPEN_SIDEBAR_LABEL = 'Открыть разделы'
export const THEME_TOGGLE_LABEL = { light: 'Включить тёмную тему', dark: 'Включить светлую тему' }
